// import Bootstrap
import 'bootstrap';

// import Swiper styles bundle
import 'swiper/css/bundle';

// import template styles
import './scss/main.scss'

import Menu from './js/components/menu/menu'
const menu = new Menu()
menu.init()

import Product from './js/product'
const product = new Product()
product.render()

import Showmore_docs from './js/components/showmore/showmore-docs'
const showmore_docs = new Showmore_docs()
showmore_docs.init()

import Popup from './js/components/popup/popup'
const popup = new Popup()
popup.init()

import MaskPhone from './js/components/mask-phone/mask-phone'
const maskPhone = new MaskPhone()
maskPhone.init()

import Anchor from './js/components/anchors/anchors'
const anchor = new Anchor()
anchor.init()

import Calc from './js/components/calc/calc'
const calc = new Calc()
calc.init()